import { render } from "./PageItemStatus.vue?vue&type=template&id=7c1dc4e0&scoped=true"
import script from "./PageItemStatus.vue?vue&type=script&lang=js"
export * from "./PageItemStatus.vue?vue&type=script&lang=js"

import "./PageItemStatus.vue?vue&type=style&index=0&id=7c1dc4e0&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1dc4e0"]])

export default __exports__